// Organization enums and constants

export const COMPENSATION_TYPE = {
    FINANCIAL: "Financial",
    TIME: "Time"
}

export const DEFAULT_COMPENSATION_TYPES = [
    COMPENSATION_TYPE.FINANCIAL,
    COMPENSATION_TYPE.TIME
];


export const CURRENCY = {
    USD: "USD",
    EUR: "EUR",
    GBP: "GBP",
    JPY: "JPY",
    CHF: "CHF",
    CAD: "CAD",
    AUD: "AUD",
    CNY: "CNY",
    SEK: "SEK",
    NOK: "NOK"
}

export const DEFAULT_CURRENCIES = [
    CURRENCY.USD,
    CURRENCY.EUR,
    CURRENCY.GBP,
    CURRENCY.JPY,
    CURRENCY.CHF,
    CURRENCY.CAD,
    CURRENCY.AUD,
    CURRENCY.CNY,
    CURRENCY.SEK,
    CURRENCY.NOK
];


export const TIME_ZONE = {
    UTC: "UTC",
    EST: "EST",
    CST: "CST",
    MST: "MST",
    PST: "PST",
    CET: "CET",
    EET: "EET",
    IST: "IST",
    JST: "JST",
    AEST: "AEST"
}

export const DEFAULT_TIME_ZONES = [
    TIME_ZONE.UTC,
    TIME_ZONE.EST,
    TIME_ZONE.CST,
    TIME_ZONE.MST,
    TIME_ZONE.PST,
    TIME_ZONE.CET,
    TIME_ZONE.EET,
    TIME_ZONE.IST,
    TIME_ZONE.JST,
    TIME_ZONE.AEST
];


export const ABSENCE_TYPE = {
    VACATION: "vacation",
    FAMILY_ASSISTANCE: "family assistance",
    SICK_LEAVE: "sick leave",
    PERSONAL_LEAVE: "personal leave",
    EXAMS: "exams",
    JUSTIFIED_ABSENCE: "justified absence",
    SPECIFIC_HOLIDAY: "specific holiday",
    UNPAID_LEAVE: "unpaid leave",
    CONGRESS: "congress",
    PARENTAL_LEAVE: "parental leave",
    OTHER: "other"
}

export const DEFAULT_ABSENCE_TYPES = [
    ABSENCE_TYPE.VACATION,
    ABSENCE_TYPE.FAMILY_ASSISTANCE,
    ABSENCE_TYPE.SICK_LEAVE,
    ABSENCE_TYPE.PERSONAL_LEAVE,
    ABSENCE_TYPE.EXAMS,
    ABSENCE_TYPE.JUSTIFIED_ABSENCE,
    ABSENCE_TYPE.SPECIFIC_HOLIDAY,
    ABSENCE_TYPE.UNPAID_LEAVE,
    ABSENCE_TYPE.CONGRESS,
    ABSENCE_TYPE.PARENTAL_LEAVE,
    ABSENCE_TYPE.OTHER
];


export const LANGUAGE = {
    ENGLISH: "en",
    PORTUGUESE: "pt"
}

export const DEFAULT_LANGUAGES = [
    LANGUAGE.ENGLISH,
    LANGUAGE.PORTUGUESE
]


export const NOTIFICATION_METHOD = {
    EMAIL: "email",
    SMS: "sms",
    PUSH: "push"
}

export const DEFAULT_NOTIFICATION_METHODS = [
    NOTIFICATION_METHOD.EMAIL,
    NOTIFICATION_METHOD.SMS,
    NOTIFICATION_METHOD.PUSH
];